<template>
  <div>
    <HTMLReport
      :header="false"
      v-show="false"
      v-if="atendimento"
      id="impressao-anamnese"
      pageSize="A4"
    >
      <div class="w-100 text-center d-inline-block">
        <div
          class="h-25 text-left"
          v-if="atendimento && atendimento.paciente && atendimento.paciente.st_nome"
        > 
          <div>
            <span class="mr-1">Atendimento:</span><strong>{{ atendimento.id_atendimento}}</strong>
          </div>
          <div>
            <span class="mr-1">Paciente:</span><strong>{{ atendimento.paciente.st_nome }}</strong>
          </div>
          <div>
            <span class="mr-1">Data:</span><strong>{{ hora }}</strong>
          </div>
        </div>
        <div
          class="font-weight-bold my-4 mx-auto"
          v-if="atendimento && atendimento.atendimento_procedimentos"
        >{{ atendimento.atendimento_procedimentos[0].procedimento.search}}</div>
        <div class="mb-4 text-left mt-1">
          <!-- <formulario mode="view" /> -->
          <Formulario ref="aa" v-model="dadosFormulario" mode="view" :printing="true" />
        </div>
      </div>
      <template v-slot:rodape>
        <rodape-medico :medico="atendimento.medico" />
      </template>
    </HTMLReport>
  </div>
</template>

<script>
import * as moment from "moment";
import HTMLReport from "../../relatorios/HTMLReport.vue";
import Formulario from "./Formulario.vue";
import RodapeMedico from '../../relatorios/consultorio/RodapeMedico.vue';

export default {
  data() {
    return {
      atendimento: null,
      hora: "",
      dadosFormulario: null,
      medicoReport: null
    };
  },
  // props: ["atendimento"],
  methods: {
    imprimirAnamnese(atendimento_, dadosFormulario_) {
      this.$util
        .loadItem(this, {
          service: "medicos",
          func: "show",
          parms: {
            id: atendimento_.id_medico
          }
        })
        .then(medico => {
          this.medicoReport = medico;
          const configPrint = {
            styles: [
              "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
              "./estilosimpressao/estilosa4.css"
            ]
          };
          let horarioAtendimento = atendimento_.dt_inicio;
          this.hora = moment(horarioAtendimento, "YYYY-MM-DD HH:mm:ss").format(
            "DD/MM/YYYY HH:mm"
          );

          this.atendimento = atendimento_;
          this.dadosFormulario = dadosFormulario_;
          console.log("medico", this.medicoReport);

          this.$nextTick(() => {
            this.$htmlToPaper("impressao-anamnese", configPrint, () => {
              console.log("print anamnese");
            });
          });
        });
    }
  },
  components: {
    HTMLReport,
    Formulario,
    RodapeMedico
  },
  computed: {},
  mounted() {}
};
</script>

<style>
</style>